import { teamExamConductContainerRoute } from '@/routes/teams/team/examConductContainer.route';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import TeamExamsConduct from '@/views/exam/ExamConduct.vue';

export const teamExamsConductRoute = {
  path: '',
  name: 'teamExamsConduct',
  component: TeamExamsConduct,
  meta: { title: 'titles.team.examConduct' },
  beforeEnter: (to: any, from: any, next: any) => {
    teamExamConductContainerRoute.meta.breadcrumb = {};

    store.commit('exam/setFilters', {
      teamId: tryParseInt(to.params.teamId),
      inheritedFromClub: true,
      clubId: undefined
    });
    next();
  }
};
